import React from 'react';

const SvgYoutube = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18.385 5.783a2.195 2.195 0 00-1.547-1.549C15.473 3.867 10 3.867 10 3.867s-5.473 0-6.838.365a2.19 2.19 0 00-1.547 1.55C1.25 7.147 1.25 10 1.25 10s0 2.852.365 4.217a2.193 2.193 0 001.547 1.549c1.365.367 6.838.367 6.838.367s5.473 0 6.838-.367a2.19 2.19 0 001.547-1.55c.365-1.364.365-4.216.365-4.216s0-2.852-.365-4.217zM8.262 12.617V7.383l4.531 2.597-4.531 2.637z" />
  </svg>
);

export default SvgYoutube;
